import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationService } from '@core/services/navigation.service';
import { SettingsService } from '@core/services/settings.service';
import { LoginPanelTriggerComponent } from '../../login-panel/login-panel-trigger/login-panel-trigger.component';
import { ZendeskButtonComponent } from '../../widget/zendesk/zendesk-button/zendesk-button.component';
import { TrustPilotComponent } from '../../widget/trust-pilot/trust-pilot.component';
import { ImageComponent } from '@shared/image/image/image.component';
import { FooterSocialGroupComponent } from './footer-social-group/footer-social-group.component';
import { FooterGroupComponent } from './footer-group/footer-group.component';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FooterGroupComponent,
        FooterSocialGroupComponent,
        NgFor,
        ImageComponent,
        TrustPilotComponent,
        ZendeskButtonComponent,
        LoginPanelTriggerComponent,
        AsyncPipe
    ]
})
export class FooterComponent {
    constructor(
        public settingsService: SettingsService,
        public navigationService: NavigationService
    ) {}
}
